import { createContext } from "react";

export const loaderContext = createContext({
  trigger: false,
  setTrigger: undefined,
});
